export enum FileActionEnum {
  Upload = 1,
  Overwrite = 2,
  Delete = 3,
  Exists = 4,
}
